<template>
  <div class="project-app"> 
    <My-new-nav ref="header"></My-new-nav>
      <div class="project-info">
        <div class="project-item">
          <div class="product-img"><img class="img1" src="../../../assets/image/product/pharmacy/project.png" alt="专业化药房系统"></div>
          <div class='flexColFirCen'>
            <div class="project-name margin-top-45">专业化药房系统</div>
            <div class="product-description">专业化药房系统，提供智慧化药店管理服务，满足药店日常电子处方开立审核，进行专业化用药咨询和个性化患者管理服务，让药房更智能。</div>
          </div>
        </div>
        <div class="project-item bg-gray">
          <ecn-title title="重构医疗产业价值服务链"></ecn-title>
          <div class="model-item flexColFirCen">
            <div class="product-img"><img class="img2345" src="../../../assets/image/product/pharmacy/model1.png" alt="智慧化药店管理服务"></div>
            <div class='flexColCen2'>
              <div class="project-name">智慧化药店管理服务</div>
              <div class="product-description">集进、销、存、财务、统计分析、营销管理为一体，满足终端日常管理，上云更安全。</div>
            </div>
          </div>
        </div>
        <div class="project-item cards">
          <carousel-3d class="card-list" :perspective="0" :border="0" :display="5" :width="612" :height="840">
            <slide v-for="(item, i) in cardList" :index="i" :key="item"  class="card-item">
                  <div class='flexColFirCen'>
                    <div class="project-name">{{item.title}}</div>
                    <div class="product-description">{{item.description}}</div>
                  </div>
                <div class="overeasy"></div>
            </slide>
          </carousel-3d>
        </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'project-app-mobile',
    data(){
      return{
        cardList: [
          {
            title: "电子处方平台服务",
            description: "满足药店开方审方需求，平台联动医生开具处方，提高药房的服务水平，服务更高效。",
          },
          {
            title: "个性化患者管理服务",
            description: "针对药店的入店客户进行全生命周期的患者管理服务，自定义分组和标签，提升药店服务质量。",
          },
          {
            title: "专业化用药咨询服务",
            description: "患者与药房药师在线即时咨询，针对性进行医师、药品推荐，提升药店的专业化服务水平。",
          }
        ] 
      }
    },
    mounted(){
       
    },
    methods: {
       
    } 
}
</script>

<style lang="scss" scoped>
  .project-app{
    // font-family: SourceHanSansCN-Regular;
    padding-top: 120px;
    div{
      box-sizing: border-box;
    }
    .margin-top-45{
      margin-top: 45px;
    }
    .project-item{
      width: 100%;
      padding: 120px 36px;
      &:first-child{
        padding-top: 0;
      }
    }
    .project-name{
      font-family: YouSheBiaoTiHei;
      color: #212121;
      line-height: 90px;
      margin-bottom: 33px;
      font-size: 90px;
    }
    .product-description{
      font-weight: 400;
      font-size: 42px;
      color: #212121;
      // font-family: PingFangSC-Regular, PingFang SC;
      line-height: 72px;
      text-align: justify;
    }
    .model-item{
      .project-name{
        font-size: 54px;
        line-height: 54px;
      }
    }
    .flexColFirCen{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .flexColCen2{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .flexRowBetCen{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .product-img{
      display: flex;
      justify-content: center;
      width: 100%;
      img{
        display: block;
      }
      .img1{
        width: 95%;
        max-width: 952px;
        margin: 60px 0;
      }
      .img2345{
        width: 94.39%;
        max-width: 848px;
      }
    }
    .ecn-title ::v-deep {
      margin-bottom: 120px;
      .title{
        font-size: 54px;
        line-height: 54px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        color: #333;
        letter-spacing: 3px;
      }
      .line{
        width: 84px;
        height: 18px;
        margin-top: 24px;
      }
    }
    .bg-gray{
      background-color: #F9F9FD;
    }
    .cards{
      padding: 160px 0;
      touch-action: pan-y pinch-zoom;
      .carousel-3d-slide.current .overeasy {
        display: none;
      }
    }
    .card-list{
      width: 100%;
      padding: 30px 0;
      box-sizing: content-box;
      .card-item{
        width: 612px;
        height: 840px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        box-shadow: 0 1px 10px 1px #ccc;
        border-radius: 21px;
        .project-name{
          width: 500px;
          text-align: left;
          font-size: 48px;
          line-height: 48px;
        }
        .product-description{
          width: 500px;
          font-size: 34px;
          line-height: 54px;
          text-align: justify;
          margin-bottom: 60px;
        }
      }
      .card-item:nth-of-type(1){
        background: url("../../../assets/image/product/pharmacy/model2.png") no-repeat center;
        background-size: 100% 100%;
      }
      .card-item:nth-of-type(2){
        background: url("../../../assets/image/product/pharmacy/model3.png") no-repeat center;
        background-size: 100% 100%;
      }
      .card-item:nth-of-type(3){
        background: url("../../../assets/image/product/pharmacy/model4.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
</style>